import EditIcon from '@mui/icons-material/Edit'

import Field from 'views/CalculateEmissions/RFQ/components/Field'
import { showMapValuesModal } from 'views/CalculateEmissions/RFQ/modals/MapValuesModal'

type ValueMappingProps<T> = {
    label: string
    outputValues: readonly T[]
    formatOutput: (value: T) => string
    mappings: [string, T][]
    onUpdate: (mappings: [string, T][]) => void
    isTradelane?: boolean
    isTransportMode?: boolean
    isCountryCode?: boolean
    autoFill?: boolean
}

const ValueMapping = <T,>({
    label,
    outputValues,
    formatOutput,
    mappings,
    onUpdate,
    isTradelane,
    isTransportMode,
    isCountryCode,
    autoFill,
}: ValueMappingProps<T>) => {
    return (
        <Field
            label={label}
            subLabel={[`${mappings.length} values mapped`]}
            rightButtonIcon={<EditIcon />}
            onClick={async () => {
                const selection = await showMapValuesModal({
                    label,
                    outputValues,
                    formatOutput,
                    mappings,
                    isTradelane,
                    isTransportMode,
                    isCountryCode,
                    autoFill,
                })
                if (selection) {
                    onUpdate(selection)
                }
            }}
            sx={{
                ...(autoFill && {
                    backgroundColor: 'Blue50',
                    '&:hover': {
                        backgroundColor: 'Blue100',
                    },
                }),
            }}
        />
    )
}

export default ValueMapping
